import { render, staticRenderFns } from "./Select845Button.vue?vue&type=template&id=01a18b30&scoped=true"
import script from "./Select845Button.vue?vue&type=script&lang=js"
export * from "./Select845Button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a18b30",
  null
  
)

export default component.exports